import React, { useEffect } from 'react';
import { dispatchBomColorChangeEvent, reloadUniqueOptions } from '../../../../bom/logics';
import {
  getUniqueOptions,
  getWhetherCurrentBomOptionGroupCanChangeProductPreviewColor,
  getWhetherNeedToDispatchBomColorChangeEvent,
} from '../../../../bom/selectors';
import { useDispatch, useSelector } from 'react-redux';

import GraphicOptionGroup from '../GraphicOptionGroup';
import PropTypes from 'prop-types';
import { QuestionType } from '../../../../bom/constants';
import { toggleSingleSelectionOption } from '../../../../bom/actions';
import { updateCurrentGalleryItemAsync } from '../../../product/logics';
import { updatePricingIfNeededForYearOptions } from '../../../../main/logics';
import { updateRecentBomOptionsList } from '../../../actions';

const GraphicSingleSelectQuestion = ({ feedback, question, resetFeedback }) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => getUniqueOptions(state, question.code));
  const canChangeProductPreviewColor = useSelector((state) =>
    getWhetherCurrentBomOptionGroupCanChangeProductPreviewColor(state, question.code)
  );
  const needToDispatchBomColorChangeEvent = useSelector((state) =>
    getWhetherNeedToDispatchBomColorChangeEvent(state, question.code)
  );

  useEffect(() => {
    const selectedOption = options.find((option) => option.isSelected);
    if (!!selectedOption && !!feedback[selectedOption.code]) {
      resetFeedback(selectedOption.code);
    }
  }, [feedback, options, resetFeedback]);

  const handleDispatchBomColorChangeEvent = (option) => {
    if (needToDispatchBomColorChangeEvent) {
      dispatchBomColorChangeEvent({ isMultiSelect: false, option });
    }
  };

  const handleSelectOption = (multiSelect, option) => {
    if (!option.isSelected) {
      dispatch(toggleSingleSelectionOption(option.code, option.codeValue));
      if (question.questionType !== QuestionType.GENERAL) {
        dispatch(reloadUniqueOptions(question));
      }
      dispatch(updatePricingIfNeededForYearOptions());
      resetFeedback(option.code);

      const dispatchedOption = { ...option, isSelected: true };
      if (canChangeProductPreviewColor) {
        dispatch(updateRecentBomOptionsList({ multiSelect, option: dispatchedOption }));
        dispatch(updateCurrentGalleryItemAsync(dispatchedOption));
      }
      handleDispatchBomColorChangeEvent(dispatchedOption);
    }
  };

  return (
    <GraphicOptionGroup feedback={feedback} options={options} question={question} onSelectOption={handleSelectOption} />
  );
};

GraphicSingleSelectQuestion.propTypes = {
  feedback: PropTypes.objectOf(PropTypes.string).isRequired,
  question: PropTypes.shape({
    code: PropTypes.string.isRequired,
    isRealParentChildQuestion: PropTypes.bool.isRequired,
    itemId: PropTypes.string.isRequired,
    mandatoryFlag: PropTypes.string.isRequired,
    needToReloadUniqueOptions: PropTypes.bool.isRequired,
    questionId: PropTypes.number.isRequired,
    questionLabel: PropTypes.string.isRequired,
    questionText: PropTypes.string.isRequired,
    questionType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
    representationType: PropTypes.oneOf([0, 1]).isRequired,
    sampleQuestionText: PropTypes.string,
    selectionType: PropTypes.oneOf([0, 1]).isRequired,
    sequence: PropTypes.number.isRequired,
    thumbnailType: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
  }).isRequired,
  resetFeedback: PropTypes.func.isRequired,
};

export default GraphicSingleSelectQuestion;
